import PropTypes from 'prop-types';
import React from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import _ from 'lodash';
import classnames from 'classnames';

/**
 * NavigationItem provides interprets individual entries in a TopNav config.
 * Clients of TopNav can choose to pass their own implementation in order to
 * provide custom logic or link types, such as react-isomorphic-router Link
 * components, for their own use cases. This ui common implementaiton provides
 * a reasonable default and a base to work from for clients that need
 * specialized logic.
 */
const NavigationItem = ({ tab, className, onClick }) => {
  const router = useRouter();

  const {
    disabled,
    secondary,
    separator,
    url,
    text,
    local,
    openInNewTab,
  } = tab || {};

  const active = router.route === url;

  if (disabled || secondary) return null;
  if (separator) {
    return <hr className='navSeparator' />;
  }

  const classes = classnames(className, { active });

  if (!local) {
    return (
      <a
        className={classes}
        href={url}
        target={openInNewTab ? '_blank' : '_self'}
        onClick={onClick}>
        {text}
      </a>
    );
  }

  /* eslint-disable jsx-a11y/anchor-is-valid */
  /* eslint-disable jsx-a11y/click-events-have-key-events */
  /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
  // next/link passes href to `a` children automatically
  return (
    <Link href={url}>
      <a className={classes} onClick={onClick} role='navigation'>{text}</a>
    </Link>
  );
};

NavigationItem.propTypes = {
  tab: PropTypes.shape({
    enabled: PropTypes.bool,
    secondary: PropTypes.bool,
    separator: PropTypes.bool,
    local: PropTypes.bool,
    url: PropTypes.string,
    text: PropTypes.string,
    openInNewTab: PropTypes.bool,
  }).isRequired,
  className: PropTypes.oneOf([
    'clearLink',
  ]),
  onClick: PropTypes.func,
};

NavigationItem.defaultProps = {
  className: null,
  onClick: _.noop,
};

export default NavigationItem;
